import { IInputNode, QuestionNode } from '../../../actionCard'

export class CheckboxQuestionNode extends QuestionNode implements IInputNode<boolean> {
  public getValue(): boolean {
    const value = this.data.value ?? false
    return !!(value as boolean)
  }

  public setValue(value?: boolean): void {
    const oldValue = this.getValue()
    this.data.value = !!value
    const newValue = this.getValue()

    this.nodeSettings?.observer?.onValueSet?.(this, newValue, oldValue)
  }

  public getStringValue(): string {
    return this.getValue().toString()
  }

  public setStringValue(value?: string): void {
    if (!value) {
      this.setValue()
      return
    }
    const parsedValue = value.toLowerCase() === true.toString().toLowerCase()
    this.setValue(parsedValue)
  }

  public stringifyValue(): string {
    return this.getValue() ? 'yes' : 'no'
  }

  public isInputEmpty(): boolean {
    return false
  }
}
